"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $q;
var $injector = angular.injector(['ng']);
$injector.invoke(['$q', function (_$q_) {
        $q = _$q_;
    }]);
exports.default = $q;
